import { render, staticRenderFns } from "./ocrRecognitionSI.vue?vue&type=template&id=49250130&scoped=true&"
import script from "./ocrRecognitionSI.vue?vue&type=script&lang=js&"
export * from "./ocrRecognitionSI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49250130",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49250130')) {
      api.createRecord('49250130', component.options)
    } else {
      api.reload('49250130', component.options)
    }
    module.hot.accept("./ocrRecognitionSI.vue?vue&type=template&id=49250130&scoped=true&", function () {
      api.rerender('49250130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocrRecognitionSI.vue"
export default component.exports